
import React from "react";
import { ChevronRight } from "lucide-react";

interface TableItem {
  id: string;
  title: string;
  icon: React.ReactNode;
}

interface TableOfContentsProps {
  items: TableItem[];
}

const TableOfContents = ({ items }: TableOfContentsProps) => {
  return (
    <section className="py-8 bg-gray-50 border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm p-6 md:p-8">
            <h2 className="text-2xl font-semibold text-elfGreen mb-4">Contents</h2>
            <nav className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {items.map((item) => (
                <a 
                  key={item.id}
                  href={`#${item.id}`}
                  className="flex items-center gap-2 p-3 hover:bg-elfGreen-light/20 rounded-lg transition group"
                >
                  <span className="text-elfGreen">{item.icon}</span>
                  <span className="flex-1">{item.title}</span>
                  <ChevronRight size={16} className="text-gray-400 group-hover:text-elfGreen transition" />
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TableOfContents;
